// import EventView from "@/views/app/organization/EventView";
import EventsView from "@/views/app/organization/EventsView";

import DashboardView from "@/views/app/organization/event/DashboardView";
// import GuestsView from "@/views/app/organization/event/GuestsView";
import GroupsView from "@/views/app/organization/event/GroupsView";
import GuestsView from "@/views/app/organization/event/GuestsView";
import CheckinView from "@/views/app/organization/event/CheckinView";
import PartnersView from "@/views/app/organization/event/PartnersView";
import CheckinLogsView from "@/views/app/organization/event/CheckinLogsView.vue";
// import EventLoadingView from "@/views/app/organization/event/EventLoadingView";
// import InvitesView from "@/views/app/organization/event/InvitesView";

import gettext from "@/language";

import { useGeneralStore } from "@/store/general.store";
import ErrorService from "@/services/error.service";

export default {
  path: "events",
  name: "app.organizations.events",
  // component: EventView,
  redirect: {
    name: "app.organizations.events.dashboard",
  },
  children: [
    {
      path: "",
      redirect: {
        name: "app.organizations.events.all",
      },
    },
    {
      path: "all",
      name: "app.organizations.events.all",
      component: EventsView,
      meta: {
        title: gettext.$gettext("Events"),
      },
    },
    {
      path: ":eventId",
      name: "app.organizations.events.single",
      // component: EventView,
      redirect: {
        name: "app.organizations.events.dashboard",
      },
      beforeEnter: async (to, from, next) => {
        const generalStore = useGeneralStore();
        let organizationId = to.params.organizationId;
        let eventId = to.params.eventId;
        if (!eventId) {
          return next({ name: "app.organizations.events.all", params: { organizationId } });
        }
        try {
          await generalStore.getEvent(organizationId, eventId);
          next();
        } catch (error) {
          // console.error("Fetch event error:", error);
          ErrorService.showError(error);
          next({ name: "app.organizations.events.all", params: { organizationId } });
        }
      },
      children: [
        {
          path: "dashboard/",
          name: "app.organizations.events.dashboard",
          component: DashboardView,
          meta: {
            title: gettext.$gettext("Dashboard"),
          },
        },
        {
          path: "guests/",
          name: "app.organizations.events.guests",
          component: GuestsView,
          meta: {
            title: gettext.$gettext("Guests"),
          },
        },
        {
          path: "checkin-logs/",
          name: "app.organizations.events.checkin-logs",
          component: CheckinLogsView,
          meta: {
            title: gettext.$gettext("Checkin Logs"),
          },
        },
        {
          path: "checkin/",
          name: "app.organizations.events.checkin",
          component: CheckinView,
          meta: {
            title: gettext.$gettext("Checkin"),
          },
        },
        {
          path: "groups/",
          name: "app.organizations.events.groups",
          component: GroupsView,
          meta: {
            title: gettext.$gettext("Groups"),
          },
        },
        {
          path: "partners/",
          name: "app.organizations.partners",
          component: PartnersView,
          meta: {
            title: gettext.$gettext("Partners"),
          },
        },
        // {
        //   path: "invites/",
        //   name: "app.organizations.events.invites",
        //   component: InvitesView,
        //   meta: {
        //     title: "Invites",
        //   },
        // },
      ],
    },
  ],
};
